import styled from 'styled-components'

export const Anchor = styled.a`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: underline;
`
